import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { style: {"margin-inline-end":"12px"} }
const _hoisted_2 = { class: "ion-padding-top" }
const _hoisted_3 = { style: {"margin-bottom":"12px"} }
const _hoisted_4 = { style: {"flex-direction":"column","width":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")!
  const _component_ion_textarea = _resolveComponent("ion-textarea")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!
  const _component_ion_fab_button = _resolveComponent("ion-fab-button")!
  const _component_ion_fab = _resolveComponent("ion-fab")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_footer = _resolveComponent("ion-footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_buttons, { slot: "start" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.backToHomePage()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_title, {
              class: "ion-text-left",
              style: {"padding-right":"0"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("h2", null, " Personalized CL template ", -1)
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_modal, {
          "keep-contents-mounted": true,
          "is-open": _ctx.section == 'experiences'
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_header, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_buttons, { slot: "start" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_button, {
                          slot: "icon-only",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.backToClaimsPage()))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_title, {
                      class: "ion-text-left",
                      style: {"padding-left":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_label, null, {
                          default: _withCtx(() => _cache[6] || (_cache[6] = [
                            _createElementVNode("h2", null, [
                              _createElementVNode("b", null, "15+ relevant experiences")
                            ], -1)
                          ])),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_ion_content, null, {
              default: _withCtx(() => [
                _createVNode(_component_ion_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pastExps, (exp, idx) => {
                      return (_openBlock(), _createBlock(_component_ion_item, {
                        lines: "none",
                        key: exp.id
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_1, [
                            _createVNode(_component_ion_checkbox, {
                              justify: "space-between",
                              labelPlacement: "end",
                              "onUpdate:modelValue": ($event: any) => (_ctx.onCheckPastExp($event, exp, idx)),
                              modelValue: _ctx.selectedExps.find(e => e.id == exp.id) != null
                            }, null, 8, ["onUpdate:modelValue", "modelValue"])
                          ]),
                          _createVNode(_component_ion_textarea, {
                            modelValue: exp.text,
                            "onUpdate:modelValue": ($event: any) => ((exp.text) = $event),
                            rows: 1,
                            placeholder: exp.placeholder || _ctx.sampleExps[idx] || ''
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                          _createVNode(_component_ion_buttons, {
                            slot: "end",
                            style: {"margin-left":"0"}
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_button, {
                                color: "danger",
                                onClick: ($event: any) => (_ctx.onDeletePastExp(exp, idx))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    size: "small",
                                    slot: "icon-only",
                                    icon: _ctx.trashOutline
                                  }, null, 8, ["icon"])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createElementVNode("div", _hoisted_2, [
                      _createVNode(_component_ion_button, {
                        fill: "outline",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onAddPastExp()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: _ctx.add
                          }, null, 8, ["icon"]),
                          _cache[7] || (_cache[7] = _createTextVNode(" New "))
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["is-open"]),
        _createElementVNode("div", null, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "ion-padding-start" }, [
            _createElementVNode("p", null, [
              _createElementVNode("b", null, "What's an ideal candidate look like?")
            ])
          ], -1)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claims, (clm, idx) => {
            return (_openBlock(), _createBlock(_component_ion_item, {
              key: idx,
              style: {"margin-bottom":"12px"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_buttons, {
                  slot: "start",
                  style: {"margin":"0","flex-direction":"column"}
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createVNode(_component_ion_checkbox, {
                        justify: "space-between",
                        labelPlacement: "end",
                        "onUpdate:modelValue": ($event: any) => (_ctx.onCheckClaim($event, clm)),
                        modelValue: _ctx.selectedClaims.find(c => c.id == clm.id) != null
                      }, null, 8, ["onUpdate:modelValue", "modelValue"])
                    ]),
                    _createVNode(_component_ion_button, {
                      onClick: ($event: any) => (_ctx.onEditClaim(clm)),
                      class: "no-text-transform"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.pencil
                        }, null, 8, ["icon"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_component_ion_button, {
                      color: "danger",
                      onClick: ($event: any) => (_ctx.presentConfirmDeleteClaim(idx)),
                      style: {"margin-top":"12px"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_icon, {
                          slot: "icon-only",
                          icon: _ctx.trashOutline
                        }, null, 8, ["icon"])
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_ion_textarea, {
                    fill: "solid",
                    modelValue: clm.text,
                    "onUpdate:modelValue": ($event: any) => ((clm.text) = $event),
                    rows: 2,
                    placeholder: `Claim ${clm.placeholder || _ctx.sampleClaims[idx] || ''}`
                  }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]),
                  _createVNode(_component_ion_textarea, {
                    fill: "solid",
                    modelValue: clm.expElaboration,
                    "onUpdate:modelValue": ($event: any) => ((clm.expElaboration) = $event),
                    rows: 6,
                    placeholder: "Evidence"
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128)),
          _createVNode(_component_ion_row, { class: "ion-justify-content-center" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_fab, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_fab_button, {
                    size: "small",
                    color: "primary",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNewClaim()))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, { icon: _ctx.add }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_ion_footer, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            _createVNode(_component_ion_button, {
              expand: "block",
              disabled: _ctx.selectedClaims.length == 0,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.copyChosenClaims())),
              class: "no-text-transform"
            }, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode(" Copy chosen claims ")
              ])),
              _: 1
            }, 8, ["disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}